/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './related-video-card.stache';
import 'dotdotdot';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'related-video-card',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isPlaying: {
                type: 'boolean',
                value: false,
            },
            isAnalyticsTracked: {
                type: 'boolean',
                value: false,
            },
        },
        play() {
            let activeVideo = this.attr('activeVideo');
            if (activeVideo) {
                activeVideo.pause();
            }
            this.player.play();
            this.attr('isPlaying', true);
            this.attr('activeVideo', this);
        },
        pause() {
            this.player.pause();
            this.attr('isPlaying', false);
        },
        isPlaying() {
            return this.player.isPlaying();
        },
        cutText(element) {
            element
                .find(
                    '.s-tag-based-related-content-slider-item__text.s-tag-based-related-content-slider-item__text--cut',
                )
                .dotdotdot();
        },
    },
    events: {
        inserted: function() {
            let player = this.element.find('brightcove-video').viewModel();
            this.viewModel.attr('player', player);
            this.element.find('video').attr('muted', 'muted');

            this.viewModel.cutText(this.element);

            window.addEventListener('resize', () => {
                this.viewModel.cutText(this.element);
            });

            player.on('videoseeking', () => {
                this.viewModel.play();
            });

            player.on('ended', () => {
                this.viewModel.pause();
            });
        },

        '.s-tag-based-related-content-slider-item__link click'(element, event) {
            event.stopPropagation();
        },

        '.s-tag-based-related-content-slider-item__video-card click'(
            element,
            event,
        ) {
            let target = $(event.target);
            const isPlayButton = target.closest('.vjs-play-control').length;
            const isInControlBar = target.closest('.vjs-control-bar').length;

            if (!isInControlBar || isPlayButton) {
                if (this.viewModel.attr('isPlaying')) {
                    this.viewModel.pause();
                } else this.viewModel.play();
            }

            if (!this.viewModel.attr('isAnalyticsTracked')) {
                const summary = this.viewModel.attr('data.title');
                if (summary) {
                    dtm.trackLiveVideoLaunch(
                        summary,
                        'Live Video Content Feed',
                    );
                    this.viewModel.attr('isAnalyticsTracked', true);
                }
            }
        },
    },
});
